import { c as _c } from "react/compiler-runtime";
import { Check } from "lucide-react";
import { colorDot } from "@osmix/ui-primitives";
import { cn } from "@/lib/utils";

// Color chip row. Two modes:
//  - display (no `onSelect`): small non-interactive dots, as on a product card.
//  - selectable (`onSelect` given): larger buttons with a selected ring + check.
export function ColorSwatches(t0) {
  const $ = _c(24);
  const {
    colors,
    selected,
    onSelect,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const dim = size === "md" ? "size-8" : "size-4";
  if (!onSelect) {
    let t2;
    if ($[0] !== className) {
      t2 = cn("flex items-center gap-1", className);
      $[0] = className;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== colors || $[3] !== dim) {
      let t4;
      if ($[5] !== dim) {
        t4 = c => <span key={c} title={c} className={cn(dim, "rounded-full border border-osmix-gray-300")} style={{
          background: colorDot(c)
        }} />;
        $[5] = dim;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      t3 = colors.map(t4);
      $[2] = colors;
      $[3] = dim;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
      t4 = <span className={t2}>{t3}</span>;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  let t2;
  if ($[10] !== className) {
    t2 = cn("flex flex-wrap items-center gap-2", className);
    $[10] = className;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== colors || $[13] !== dim || $[14] !== onSelect || $[15] !== selected) {
    let t4;
    if ($[17] !== dim || $[18] !== onSelect || $[19] !== selected) {
      t4 = c_0 => {
        const active = c_0 === selected;
        const swatch = colorDot(c_0);
        const light = swatch === "#ffffff" || swatch === "#e5e7eb";
        return <button key={c_0} type="button" title={c_0} aria-pressed={active} onClick={() => onSelect(c_0)} className={cn(dim, "flex items-center justify-center rounded-full border transition-all", active ? "border-osmix-tangelo ring-2 ring-osmix-tangelo/30" : "border-osmix-gray-300 hover:border-osmix-text-2")} style={{
          background: swatch
        }}>{active && <Check className={cn("size-4", light ? "text-osmix-text-1" : "text-white")} />}</button>;
      };
      $[17] = dim;
      $[18] = onSelect;
      $[19] = selected;
      $[20] = t4;
    } else {
      t4 = $[20];
    }
    t3 = colors.map(t4);
    $[12] = colors;
    $[13] = dim;
    $[14] = onSelect;
    $[15] = selected;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[21] !== t2 || $[22] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}